import { ActiveInfoDialog, ActiveTextDialog, CorrectDialog, IncorrectDialog } from "../Dialogs";
import { STATE_POINT, TYPE_POINTS } from "../../utils/constants";
import classes from "./Point.module.scss";
import clsx from 'clsx';

export default function Point(props) {

    const { onClick, disabled, type, state, showBalloon = false, isInfoScreenActive } = props;

    const hasBallon = () => {
        if (showBalloon && ((state === STATE_POINT.FOCUS && [TYPE_POINTS.SELECTION, TYPE_POINTS.INFO, TYPE_POINTS.TEXT].includes(type)) || (state === STATE_POINT.INCORRECT && [TYPE_POINTS.SELECTION, TYPE_POINTS.TEXT].includes(type)))) {
            return true;
        }
        return false;
    }

    return (

        <button className={classes.interactivezone} type="button" data-interactive-point="true" onClick={onClick} disabled={disabled} aria-pressed={hasBallon()}>

            {(showBalloon && state === STATE_POINT.FOCUS && type === TYPE_POINTS.SELECTION) && (<CorrectDialog />)}
            {(showBalloon && state === STATE_POINT.INCORRECT && (type === TYPE_POINTS.SELECTION || type === TYPE_POINTS.TEXT)) && (<IncorrectDialog />)}
            {(showBalloon && state === STATE_POINT.FOCUS && type === TYPE_POINTS.INFO) && (<ActiveInfoDialog />)}
            {(showBalloon && state === STATE_POINT.FOCUS && type === TYPE_POINTS.TEXT) && (<ActiveTextDialog />)}

            <div className={
                clsx(classes.point,
                    {
                        [classes.information]: type === TYPE_POINTS.INFO,
                        [classes.selection]: type === TYPE_POINTS.SELECTION,
                        [classes.text]: type === TYPE_POINTS.TEXT,
                        [classes.correct]: state === STATE_POINT.CORRECT,
                        [classes.incorrect]: state === STATE_POINT.INCORRECT,
                        [classes.focus]: state === STATE_POINT.FOCUS,
                        [classes.default]: state === STATE_POINT.DEFAULT,
                        [classes.disabled]: isInfoScreenActive,
                    })
            }>
            </div>
        </button >
    )
}